import { color } from 'core/theme/util'
import React from 'react'
import styled from 'styled-components'

const Footer = () => {
    return (
        <FooterContainer>
            <div className="regular">
                © 2024{' '}
                <a href="https://swmansion.com/" target="_blank" rel="noreferrer">
                    Software Mansion
                </a>
                , courtesy of{' '}
                <a href="https://github.com/Devographics" target="_blank" rel="noreferrer">
                    Devographics
                </a>
            </div>
            <div className="extra-small">
                Questions? Found a bug?{' '}
                <a href="https://discord.gg/VcKPaxUAnY" target="_blank" rel="noreferrer">
                    Leave an issue.
                </a>
            </div>
        </FooterContainer>
    )
}

const FooterContainer = styled.div`
    border-top: 1px solid ${color('primary100')};

    width: 100%;
    height: 198px;
    background: ${color('brandGreen60')};
    padding: 48px 0;
    display: flex;
    flex-direction: column;
    gap: 48px;
    justify-content: center;
    align-items: center;
    a {
        font-weight: 500;
        color: ${color('primary100')};
    }
`

export default Footer
